import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { listBoxes, listMoves } from "../api/accounting";
import { AcctShell } from "../features/acct/AcctShell";
import { NeuCard, NeuSelect } from "../components/neu/Neu";
import { DateInput } from "../components/neu/DateInput";

export default function AcctTxnPage() {
  const { t } = useTranslation();
  const [boxes, setBoxes] = useState([]);
  const [moves, setMoves] = useState([]);
  const [filters, setFilters] = useState({ cashbox_id: "", direction: "", date_from: "", date_to: "" });

  const load = useCallback(async () => {
    const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => v));
    setMoves(await listMoves(params));
  }, [filters]);

  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    listBoxes().then(setBoxes);
  }, []);


  const set = (key) => (e) => setFilters((prev) => ({ ...prev, [key]: e.target.value }));

  return (
    <AcctShell titleKey="transactions">
      <div className="grid gap-3 sm:grid-cols-4">
        <NeuSelect data-testid="txn-box" value={filters.cashbox_id} onChange={set("cashbox_id")}>
          <option value="">{t("acct.allBoxes")}</option>
          {boxes.map((b) => (
            <option key={b.id} value={b.id}>{b.name}</option>
          ))}
        </NeuSelect>
        <NeuSelect data-testid="txn-direction" value={filters.direction} onChange={set("direction")}>
          <option value="">{t("acct.allDirections")}</option>
          <option value="in">{t("acct.in")}</option>
          <option value="out">{t("acct.out")}</option>
        </NeuSelect>
        <DateInput testId="txn-from" value={filters.date_from} onChange={(v) => setFilters((p) => ({ ...p, date_from: v }))} />
        <DateInput testId="txn-to" value={filters.date_to} onChange={(v) => setFilters((p) => ({ ...p, date_to: v }))} />
      </div>

      <NeuCard className="overflow-x-auto p-4" data-testid="txn-list">
        <table className="w-full min-w-[600px] text-xs">
          <thead>
            <tr className="text-[11px] text-muted-foreground">
              <th className="p-2 text-start">{t("acct.date")}</th>
              <th className="p-2 text-start">{t("acct.source")}</th>
              <th className="p-2 text-start">{t("acct.description")}</th>
              <th className="p-2 text-end">{t("acct.in")}</th>
              <th className="p-2 text-end">{t("acct.out")}</th>
              <th className="p-2 text-end">{t("acct.balance")}</th>
              <th className="p-2 text-end">{t("acct.entry")}</th>
            </tr>
          </thead>
          <tbody>
            {moves.map((mv) => (
              <tr key={mv.id} className="border-t border-border/40" data-testid={`txn-row-${mv.id}`}>
                <td className="p-2 font-mono" dir="ltr">{mv.date}</td>
                <td className="p-2">{t(`acct.sources.${mv.source}`, mv.source)}</td>
                <td className="p-2">{mv.description || "—"}</td>
                <td className="p-2 text-end font-mono text-success" dir="ltr">{mv.direction === "in" ? mv.amount : ""}</td>
                <td className="p-2 text-end font-mono text-destructive" dir="ltr">{mv.direction === "out" ? mv.amount : ""}</td>
                <td className="p-2 text-end font-mono font-bold" dir="ltr">{mv.balance_after}</td>
                <td className="p-2 text-end font-mono text-primary" dir="ltr">{mv.entry_number}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </NeuCard>
    </AcctShell>
  );
}
